import { createContext } from "react";
import { UiData } from "./ui-data";

export const UiDataContext = createContext<UiData>(null as unknown as UiData);
